module.exports = __webpack_public_path__ + "static/p-kembali-berjumpa-2649134fc62e4257c31f4d242bd25bde.jpg";